export function agofHit(route) {
  if (global.IOMm && route) {
    global.IOMm('pageview', { cp: route });
  }
}
